import React, { useEffect, useState } from "react";
import images from "../../assets/images/Constant";
import Button from "../ui/Button";
import homeData from "../../data/home.json";
import { GoArrowUpRight } from "react-icons/go";
import { LiaBoxSolid, LiaWarehouseSolid } from "react-icons/lia";
import Service from "../Service/Service";
import { Link } from "react-router-dom";

const Hero = () => {
  const [activeTab, setActiveTab] = useState(0);
  const hero = homeData?.hero || {};
  const tracking = homeData?.tracking || {};
  const [currentIndex, setCurrentIndex] = useState(0);

const bannerImages = [
  images.Banner,
  images.Banner1,
  images.Banner2,
];

useEffect(() => {
  const len = bannerImages.length;
  const interval = setInterval(() => {
    setCurrentIndex((prev) => (prev + 1) % len);
  }, 3000); // 3 sec

  return () => clearInterval(interval);
}, [bannerImages.length]);
  // services data handled inside <Service />

  return (
    <div className="w-full">

      {/* HERO SECTION */}
      <section className="relative w-full max-w-[100vw] h-[480px] sm:h-[520px] md:h-[700px] overflow-hidden">

  {/* 🔥 SLIDER IMAGES */}
  {bannerImages.map((img, index) => (
    <img
      key={index}
      src={img}
      alt=""
      className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 
      ${currentIndex === index ? "opacity-100" : "opacity-0"}`}
    />
  ))}

  {/* 🔥 CONTENT (STATIC) */}
  <div className="relative max-w-[1200px] mx-auto h-full flex items-center px-6">
    <div className="text-white max-w-[700px]">
      <h1 className="text-3xl md:text-heading leading-tight font-extrabold">
        {hero.title}
      </h1>

      <p className="mt-4 text-gray-200 text-sm md:text-base max-w-[560px]">
        {hero.description}
      </p>
<Link to="/contact">
      <Button>{hero.buttonText}</Button>
      </Link>
    </div>
  </div>

  {/* 🔥 RIGHT SIDE VERTICAL DOTS */}
  <div className="absolute right-6 top-1/2 -translate-y-1/2 flex flex-col gap-3 z-20">
    {bannerImages.map((_, index) => (
      <span
        key={index}
        onClick={() => setCurrentIndex(index)}
        className={`w-3 h-3 rounded-full cursor-pointer transition-all
        ${currentIndex === index ? "bg-slate-200 scale-125" : "bg-primary"}`}
      ></span>
    ))}
  </div>

</section>

      {/* TRACKING BOX */}
      <div className="w-full flex justify-center -mt-10 md:-mt-16 relative z-10 px-4">
      
      <div className="bg-[#FAFAFA] shadow-lg rounded-xl w-full max-w-[1100px] border border-gray-200">

        {/* Tabs */}
        <div className="flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-2 px-4 sm:px-6 pt-4 sm:pt-5 border-b border-gray-200 relative">

          {/* Left Tab */}
          <button
            onClick={() => setActiveTab(0)}
            className={`pb-3 sm:pb-4 flex justify-center items-center gap-2 text-base sm:text-lg font-medium  ${
              activeTab === 0 ? "text-black" : "text-[#0A0A0A]"
            }`}
          >
            <LiaBoxSolid className="w-5 h-5" />
            {tracking?.tabs?.[0]}
          </button>

          {/* Right Tab */}
          <button
            onClick={() => setActiveTab(1)}
            className={`pb-3 sm:pb-4 text-base sm:text-lg font-medium flex justify-center items-center gap-2   ${
              activeTab === 1 ? "text-black" : "text-[#0A0A0A]"
            }`}
          >
            <LiaWarehouseSolid className="w-5 h-5"/>
 
            {tracking?.tabs?.[1]}
                     </button>

          {/* Bottom full line */}
          <div className="absolute bottom-0 left-0 w-full h-[2px] bg-gray-200"></div>

          {/* Active underline */}
          <div
            className={`absolute bottom-0 h-[2px] bg-primary transition-all duration-300`}
            style={{
              width: "50%",
              left: activeTab === 0 ? "0%" : "50%",
            }}
          ></div>
        </div>

        {/* Form */}
        <div className="p-6 flex flex-col md:flex-row gap-4">

          {/* Order ID */}
          <div className="flex items-center bg-[#EEEEEE] rounded-md px-4 py-3 flex-1">
            <span className="text-[#404040] text-base whitespace-nowrap">
              Order ID
            </span>

            <div className="w-px h-5 bg-gray-300 mx-3"></div>

            <input
              type="text"
              placeholder="Enter ID number"
              className="bg-transparent outline-none text-sm w-full placeholder-[#C5C5C5]"
            />
          </div>

          {/* Email */}
          <div className="flex items-center bg-[#EEEEEE] rounded-md px-4 py-3 flex-1">
            <span className="text-[#404040] text-base whitespace-nowrap">
              Your E-mail
            </span>

            <div className="w-px h-5 bg-gray-300 mx-3"></div>

            <input
              type="email"
              placeholder="Enter Your Email"
              className="bg-transparent outline-none text-sm w-full placeholder-[#C5C5C5]"
            />
          </div>

          {/* Button */}
          <button className="bg-primary hover:bg-primary text-white px-6 py-3 rounded-md flex items-center justify-center gap-2 text-sm font-medium whitespace-nowrap">
            {tracking?.buttonText}
            <GoArrowUpRight />
          </button>

        </div>
      </div>
    </div>
<Service />
    </div>
  );
};

export default Hero;